<template>
  <div class="page-home">
    <div class="content-wrap" ref="contentBScrollWrap">
      <div class="home-wrap" :class="isFirst ? 'bg1' : 'bg2'">
        <music v-show="showMusic" ref="music"></music>
        <!-- <audio id="btn_bgm" src="../../assets/img/btn_music.wav"></audio> -->
        <img v-show="isFirst" src="../../assets/img/kits.png" class="kits" @click="seeKits">
        <!-- <img src="../../assets/img/logo.png" v-if="isFirst" class="logo"> -->
        <!-- <img src="https://cmbc-zg.oss-cn-shenzhen.aliyuncs.com/home_bottom.png" v-if="isFirst" class="home_bottom"> -->
        <div class="first_page" v-if="isFirst">
          <!-- <img src="../../assets/img/home_title.jpg" class="home_title"> -->
          <img src="../../assets/img/begin.png"  class="begin_btn" @click="beginTest">
        </div>
        <div class="problem_page" v-if="!isFirst">
          <img :src='imgArr.p_title' class="p_title" :class="toNext ? 'moveLeft' : ''">
          <img :src='imgArr.p_img' class="p_img" :class="toNext ? 'moveIn' : ''">
          <div class="answer_box">
            <div class="answer_left">
              <img :src='imgArr.p_a' class="p_a" :class="[choosedVal === 'A' ? 'active' : '', toNext ? 'rotateLeft' : '']" @click="toAnswer('A')">
              <img :src='imgArr.p_b' class="p_b" :class="[choosedVal === 'B' ? 'active' : '', toNext ? 'rotateLeft2' : '']" @click="toAnswer('B')">
            </div>
            <div class="answer_right">
              <img :src='imgArr.p_c' class="p_c" :class="[choosedVal === 'C' ? 'active' : '', toNext ? 'rotateRight' : '']" @click="toAnswer('C')">
            </div>
          </div>
        </div>
      </div>
      <tipBox :tipStyle='showTipBox' v-if="showTipBox" v-on:listenTipMag="fromChidFun"></tipBox>
      <shareBox ref="shareBox"></shareBox>
    </div>
    <award :isShow.sync="showAward"></award>
  </div>
</template>

<script>
import { Toast } from 'vant'
import shareBox from '../../components/shareBox'
import tipBox from '../../components/tipBox'
import music from '../../components/music'
import award from '../../components/award'
export default {
  name: 'page-home',
  data () {
    return {
      showTipBox: null,
      btn_bgm: null,
      isFirst: true,
      nowIdx: 1, // 当前题号
      choosedVal: '', // 当前答案
      answerArr: [],
      toNext: false, // 控制切换动画
      total: 5,
      isChoosing: false,
      testResult: null, // 测试结果
      showMusic: false,
      showAward: false
      // imgBefore: 'https://cmbc-zg.oss-cn-shenzhen.aliyuncs.com/p'
    }
  },
  computed: {
    imgArr () {
      const json = {}
      json.p_title = require(`../../assets/img/p${this.nowIdx}_title.png`)
      json.p_img = require(`../../assets/img/p${this.nowIdx}_img.png`)
      json.p_a = require(`../../assets/img/p${this.nowIdx}_a.png`)
      json.p_b = require(`../../assets/img/p${this.nowIdx}_b.png`)
      json.p_c = require(`../../assets/img/p${this.nowIdx}_c.png`)
      return json
    }
  },
  components: { tipBox, music, shareBox, award },
  async created () {
    // await this.initBScroll()
  },
  async mounted () {
    console.log('有无奖品', this.$store.state.userPrize)
    await this.setWxShare()
    this.$stat({
      event: 'home_page' // 上报渠道事件
    })
    // 音效
    // let mp3 = require('../../assets/img/btn_music.mp3')
    // this.btn_bgm = new Audio(mp3)
    // this.btn_bgm.muted = true
    // this.btn_bgm.play()
    this.$refs.music.prePlay(1)
  },
  methods: {
    async beginTest () {
      this.$stat({
        event: 'start_btn' // 上报埋点信息
      })
      console.log(11, this.$store.state.overTime, this.$store.state.is_subscribe)
      if (!this.$store.state.is_subscribe) { // 记得改回来
        this.showTipBox = 3
        try {
          await this.$fetch.get('fq-test/send-message')
        } catch (error) {
          console.log('error', error)
          Toast(error.response.data.message)
        }
      } else {
        this.showMusic = true
        this.isFirst = false
        this.$refs.music.playBtn()
      }
    },
    toAnswer (val) {
      if (this.isChoosing) {
        return
      }
      this.isChoosing = true
      this.$refs.music.playBtnBgm() // 按钮音效
      // this.btn_bgm.muted = false
      // this.btn_bgm.play()
      this.toNext = false
      this.choosedVal = val
      this.answerArr.push(val)
      const timer = setTimeout(() => {
        if (this.nowIdx < this.total) {
          this.toNext = true
          const timer2 = setTimeout(() => {
            this.nowIdx++
            this.choosedVal = ''
            clearTimeout(timer2)
            this.isChoosing = false
          }, 600)
        } else {
          this.judge()
        }
        clearTimeout(timer)
      }, 300)
    },
    async judge () {
      const answer = this.answerArr.toString()
      const { data } = await this.$fetch.get('fq-test/answer', { answers: answer })
      console.log(data, answer, this.answerArr)
      this.testResult = data.index
      // const num = this.answerArr.reduce((pre, cur) => {
      //   if (cur === 'a') {
      //     pre++
      //   }
      //   return pre
      // }, 0)
      // switch (num) {
      //   case 0:
      //     this.testResult = 1
      //     break
      //   case 1:
      //     this.testResult = 1
      //     break
      //   case 2:
      //     this.testResult = 2
      //     break
      //   case 3:
      //     this.testResult = 3
      //     break
      //   case 4:
      //     this.testResult = 4
      //     break
      //   case 5:
      //     this.testResult = 5
      //     break
      // }
      this.$store.commit('setResult', this.testResult)
      this.$refs.music.toStop()
      this.$router.push({ path: 'poster' })
    },
    seeKits () {
      // console.log(11111)
      this.showAward = true // 打开我的奖品组件
      this.$stat({
        event: 'kits_btn' // 上报渠道事件
      })
    },
    fromChidFun (data) {
      if (data === 'close') {
        this.showTipBox = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/animate';
$heightVal: 680px;
.page-home{
}
.home-wrap{
  width: 100%;
  height: auto;
  min-height: 100vh;
  // background: url('../../assets/img/home_title.jpg') no-repeat;
  // background-size: 100%;
  background-color: #f8c3c9;;
}
.bg1{
  background: url('../../assets/img/home_title.jpg') no-repeat;
  background-size: 100%;
  background-color: #f8c3c9;
}
.bg2{
  background: url('../../assets/img/p1_bg.png') no-repeat;
  background-size: 100% 100%;
}
.logo{
  position:absolute;
  top:1.4%;
  left: 35px;
  width: 247px;
}
.kits{
  position: absolute;
  width:93px;
  height: auto;
  top: 0.4rem;
  right: 0.4rem;
  z-index: 2;
}
.home-wrap{
  position: relative;
  width: 100%;
  height: 100%;
  .p_title{
    position: absolute;
    top: 3%;
    @media (min-height: $heightVal) {
      top: 6%;
    }
    // top: 6%;
    left: 21px;
    margin-left: 21px;
    // width: 595px;
    // height: auto;
    // height: 105px;
    width: 711px;
    height: auto;
  }
  .p_img{
    position: absolute;
    // top: 17.8%;
    bottom: 50%;
    transform: translateY(30%);
    // left: 23px;
    margin-top: 12px;
    margin-left: 23px;
    width: 750px;
    height: auto;
    // z-index: 3;
  }
  .answer_box{
    position: absolute;
    @media (min-height: $heightVal) {
      bottom: 2%;
    }
    // bottom: 2%;
    bottom: 0;
    left: 21px;
    width: auto;
    height: auto;
    img{
      -webkit-filter: grayscale(100%) brightness(110%); /* Chrome, Safari, Opera */
      filter: grayscale(100%) brightness(110%);
    }
    .answer_left{
      display: inline-block;
      width: 338px;
      height: auto;
      font-size: 0;
      margin-right: 18px;
      .p_a{
        width: 338px;
        height: auto;
      }
      .p_b{
        width: 336px;
        height: auto;
        margin-top: 16px;
      }
    }
    .answer_right{
      display: inline-block;
      width: 363px;
      height: auto;
      .p_c{
        width: 363px;
        height: auto;
      }
    }
  }
  .active{
    filter:none !important;
    -webkit-filter:none !important;
    z-index: 2;
  }
  .moveIn{
    animation: moveIn 1.8s;
  }
  .moveLeft{
    animation: moveLeft 1.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    // (.87,-.41,.19,1.44)
  }
  .rotateLeft{
    animation: rotateLeft 1.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  .rotateLeft2{
    animation: rotateLeft2 1.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  .rotateRight{
    animation: rotateRight 1.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
}
.first_page{
  width: auto;
  height: 100vh;
  position: relative;
  // .home_title{
  //   width: auto;
  //   height: 70%;
  //   margin-bottom: 23px;
  //   pointer-events: none;
  // }
  .begin_btn{
    position: absolute;
    top: unset;
    bottom: 1%;
    left: 203px;
    width: 344px;
    height: auto;
    display: block;
    margin:auto;
    animation: btnAnimate 0.8s ease-in-out infinite;
    @media (min-height: $heightVal) {
      bottom: unset;
      top: 1099px;
    }
  }
}
.home_bottom{
  position: absolute;
  width: 100%;
  bottom: -2%;
  left: 0;
}
</style>
